/* eslint-disable
    consistent-return,
    no-return-assign,
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

import {NucleotideType} from 'biojs/BioConstants';
import * as popup from 'Popup';

class SecondaryStructure extends Backbone.Model {
  getSvg(height, script) {
    if (script == null) {
      script = true;
    }
    let svg = this.get('svg');
    const dg = this.get('dg');
    const name = this.get('name');
    const nucleotideType = this.get('nucleotideType');
    let svgEl = $(svg)[2];
    let middle;
    $(svgEl)
      .find('text')
      .each(function () {
        const $this = $(this);
        if ($this.text() === '&') {
          return (middle = `${$this.attr('x')},${$this.attr('y')}`);
        }
      });
    if (middle != null) {
      svg = svg.replace(
        middle,
        '" /><polyline style="stroke: black; fill: none; stroke-width: 1.5" id="outline" points="'
      );
    }
    svgEl = $(svg)[2];
    let reached = false;
    $(svgEl)
      .find('text')
      .each(function () {
        const $this = $(this);
        if (middle != null) {
          // dimer
          if ($this.text() === '&') {
            reached = true;
            $this.remove();
          } else {
            const fill = reached ? '#1c5981' : '#86271e';
            $this.attr('fill', fill);
          }
        } else {
          $this.attr('fill', '#1c5981');
        }
        if (nucleotideType === NucleotideType.DNA && $this.text() === 'U') {
          $this.text('T');
        }
        if (nucleotideType === NucleotideType.DNA && $this.text() === 'u') {
          return $this.text('t');
        }
      });
    $(svgEl).find('#seq').attr('style', '');
    $(svgEl).find('polyline').css('stroke', '#dadada');
    $(svgEl).find('#pairs').css('stroke', '#dadada');
    const curHeight = $(svgEl).attr('height');
    $(svgEl).attr('width', height).attr('height', height).css('cursor', 'pointer');
    svgEl.setAttribute('viewBox', `0 0 ${curHeight} ${curHeight}`);

    if (!script) {
      $(svgEl).find('script').remove();
      $(svgEl).find('rect').attr('onclick', '');
      $(svgEl).find('#seq').removeAttr('id');
    }
    return svgEl;
  }

  showModal() {
    const modalHeight = $(window).height() - 200;
    const curHeight = $(this.get('svg')).attr('height');
    const height = modalHeight < curHeight ? modalHeight : curHeight;
    const svgEl = this.getSvg(height);
    const modalEl = $('<div>').addClass('text-center').html(svgEl);
    const ref =
      'Secondary structure analysis performed by <a href="http://www.tbi.univie.ac.at/~ronny/RNA/index.html" target="_blank">ViennaRNA</a>.';
    modalEl.append($('<p>').html(ref).addClass('pull-right'));
    return new popup.Confirm({
      title: `${this.get('name')}: ${this.get('dg')} kcal`,
      msg: modalEl[0],
      noPadding: true,
    })
      .choice('Done', 'button--tertiaryGray')
      .show();
  }
}

export default SecondaryStructure;
